// Add loading state immediately
  document.documentElement.classList.add("loading");

  window.addEventListener("load", function () {
    const loader = document.getElementById("door-loader");

    // Small delay so logo is visible first
    setTimeout(() => {

      // Start smooth blend
      loader.classList.add("loaded");
      document.documentElement.classList.add("loaded");

      // Remove loader after animation completes
      setTimeout(() => {
        if (loader) loader.remove();
      }, 1600); // matches CSS duration

    }, 300); // shorter = smoother feel
  });















// document.documentElement.classList.add('loading');

// document.addEventListener('DOMContentLoaded', function () {
//   const loader = document.getElementById('door-loader');

//   setTimeout(() => {

//     loader.classList.add('loaded');
//     document.documentElement.classList.remove('loading');

//     setTimeout(() => {
//       loader.remove();
//     }, 8000);

//   }, 400);
// });





// document.documentElement.classList.add('loading');

// document.addEventListener('DOMContentLoaded', function () {
//   const loader = document.getElementById('door-loader');

//   setTimeout(() => {
//     loader.classList.add('loaded');
//     document.documentElement.classList.remove('loading');

//     setTimeout(() => {
//       loader.remove();
//     }, 5000);
//   }, 300);
// });

